import React, { useState } from 'react';
import { Form, Button, Row, Col, Card, Spinner, Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';
import dbService from '../../../services/dbService';
import { useAuth } from '../../../context/AuthContext';

const TransactionScreening = ({ watchlists }) => {
    const keywordList = watchlists.find(wl => wl.type === 'Keyword')?.entries || [];
    const [formData, setFormData] = useState({ counterparty: '', memo: '' });
    const [result, setResult] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { user } = useAuth();

    const handleScreening = (e) => {
        e.preventDefault();
        setIsLoading(true);
        setResult(null);
        let hitKeyword = '';

        for (const keyword of keywordList) {
            if (formData.memo.toLowerCase().includes(keyword.toLowerCase())) {
                hitKeyword = keyword;
                break;
            }
        }

        setTimeout(() => {
            if (hitKeyword) {
                setResult({ status: 'Hit', keyword: hitKeyword });
            } else {
                setResult({ status: 'Clear' });
            }
            dbService.addLog({ user: user.name, action: 'Transaction Screening', details: `Screened memo. Result: ${hitKeyword ? 'Hit' : 'Clear'}` });
            setIsLoading(false);
        }, 1000);
    };

    return (
        <div>
            <p>Screen individual transaction details, such as counterparties or payment memos, against specialized keyword lists for suspicious terms.</p>
             <Card>
                <Card.Body>
                    <Form onSubmit={handleScreening}>
                        <Row>
                            <Col md={6}><Form.Group className="mb-3"><Form.Label>Counterparty Name</Form.Label><Form.Control type="text" value={formData.counterparty} onChange={e => setFormData({...formData, counterparty: e.target.value})} /></Form.Group></Col>
                            <Col md={6}><Form.Group className="mb-3"><Form.Label>Transaction Memo / Details</Form.Label><Form.Control as="textarea" rows={2} value={formData.memo} onChange={e => setFormData({...formData, memo: e.target.value})} required /></Form.Group></Col>
                        </Row>
                        <Button type="submit" disabled={isLoading}>{isLoading ? <Spinner as="span" size="sm" /> : 'Screen Transaction'}</Button>
                    </Form>
                </Card.Body>
            </Card>
             {result && (
                <Alert variant={result.status === 'Hit' ? 'warning' : 'success'} className="mt-4">
                    <Alert.Heading>{result.status === 'Hit' ? 'Suspicious Keyword Found' : 'Transaction Clear'}</Alert.Heading>
                    {result.status === 'Hit' ? (
                        <p>The transaction memo contained the keyword: <strong>"{result.keyword}"</strong>. This transaction may require additional scrutiny.</p>
                    ) : <p>The transaction details appear to be clear of any suspicious keywords.</p>}
                </Alert>
            )}
        </div>
    );
};

export default TransactionScreening;